<!-- not used-->

<template>
  <v-row class="mx-0 mt-5 mb-4"> operator redirection pending status </v-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
